export default "__VITE_ASSET__DUpVSbIR__"